// extracted by mini-css-extract-plugin
export default {"child1":"styles_child1__8R4Cu","child2":"styles_child2__hyqKx","parent":"styles_parent__S5Cbu"};